import * as React from 'react'

import { Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

interface Props {
  field: Field
  readonly: boolean
  onChange: (value: boolean) => void
}

const Accrues = ({ field, onChange, readonly }: Props) => (
  <Card extra={{ 'data-intercom-target': 'leave-type-accrues-input' }}>
    <Card.Title
      size="small"
      action={<TogglerCheckbox value={field.value} onChange={onChange} disabled={readonly} />}
    >
      {i18n.t('settings.leave_types.page.allowance.form.accrue.label')}
    </Card.Title>
  </Card>
)

export default Accrues
